<template>
  <b-row>
    <b-col cols="12">
      <company-size-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CompanySizeContent from './CompanySizeContent.vue'

export default {
  components: {
    BRow,
    BCol,

    CompanySizeContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>